import * as React from 'react';
type Props = {
  className?: string;
};
export function Garlic({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Garlic"
      className={className}
    >
      <g clipPath="url(#clip0_1154_12333)">
        <path
          d="M19.7812 9.38V3.47998H16.5829V9.68005C14.173 11.1601 1.86831 17.81 6.64363 24.23C8.35386 26.54 12.1963 25.92 12.2851 25.9C12.2488 25.8692 12.2154 25.8358 12.1852 25.8C13.1536 26.5968 14.3342 27.1546 15.6127 27.4192C16.8911 27.6838 18.2238 27.6462 19.4814 27.3101C20.7211 26.9739 21.8601 26.3892 22.813 25.6C22.9463 25.6 26.5222 26.47 28.3657 24.42C33.7407 18.43 21.0695 11.48 19.7812 9.38ZM23.2017 25.29L23.3683 25.12L23.2017 25.29Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M26.6445 30.38C23.8348 31.44 20.3921 31.49 19.5148 31.89C18.1266 32.51 18.9484 33.8901 19.6481 34.6601C20.0848 35.1718 20.5798 35.6411 21.125 36.0601C23.1018 37.5401 26.6777 37.53 28.8988 36.6C30.8264 35.804 32.3938 34.4385 33.3409 32.73C34.3778 30.6669 34.7842 28.3919 34.5182 26.14C34.5182 25.91 34.5181 25.6801 34.1516 25.7901C31.9261 27.6585 29.3941 29.2066 26.6445 30.38Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M30.0538 33C29.5089 33.6339 28.8196 34.1555 28.0324 34.5298C27.2452 34.9041 26.3782 35.1224 25.4895 35.17"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M24.279 17.53C22.9598 14.7508 21.477 12.037 19.8368 9.40002V3.5H16.6384V9.77002C16.3894 10.206 16.1151 10.63 15.8167 11.04C13.2624 14.29 9.05336 18.04 10.1417 22.63C10.3994 23.5031 10.85 24.3205 11.4666 25.0332C12.0831 25.7459 12.8529 26.3395 13.7299 26.7782C14.607 27.2169 15.5732 27.492 16.5709 27.5868C17.5687 27.6816 18.5775 27.5942 19.5369 27.33C24.0235 26.06 25.9892 22.83 24.279 17.53Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_1154_12333">
          <rect
            width={30.14}
            height={34.74}
            fill="white"
            transform="translate(5 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
